<template>
    <div class="container-fluid">
        <admin-header :name="$t('Settings')"/>
        <app-card>
            <ul class="nav nav-pills">
                <li v-for="(setting, i) in settings" :key="i" class="nav-item">
                    <router-link v-if="$store.getters.canViewSettings" :to="setting.url" class="nav-link" exact>
                        {{ $t(setting.name) }}
                    </router-link>
                </li>
            </ul>

            <div class="tab-content">
                <router-view name="settings"/>
            </div>
        </app-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            settings: [
                {url:'/auth/settings', name: 'Price lists' },
                {url:'/auth/settings/booking', name: 'Booking' },
                {url:'/auth/settings/services', name: 'Services' },
                {url:'/auth/settings/locations', name: 'Locations' },
                {url:'/auth/settings/promocodes', name: 'Promocodes' },
                {url:'/auth/settings/additions', name: 'Additional eq' },
                {url:'/auth/settings/makes-models', name: 'Makes and models' },
                {url:'/auth/settings/vehicle-groups', name: 'Vehicle groups' },
                {url:'/auth/settings/public-pages', name: 'Public pages' },
            ]
        };
    }
};
</script>
